module.exports = __webpack_public_path__ + "static/img/korisnici1.53ce57c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/korisnici1.png
// module id = g/j2
// module chunks = 0